import * as Bixby from '$/core';

export abstract class PrivateEquitySponsorService {
  private static adminBaseUrl = `${Bixby.Constants.API_ADMIN_PREFIX}/${Bixby.Constants.API_PRIVATEEQUITYSPONSORCONTROLLER}`;

  public static async getPrivateEquitySponsors(): Promise<Bixby.Models.PrivateEquitySponsor[]> {
    const route = Bixby.API.ServerRoute.forAction(
      `${PrivateEquitySponsorService.adminBaseUrl}`
    );
    return await Bixby.API.get(route);
  }

  public static async createPrivateEquitySponsors(command: Bixby.Models.PrivateEquitySponsorCreateRequest): Promise<Bixby.Models.PrivateEquitySponsor> {
    const route = Bixby.API.ServerRoute.forAction(
      `${PrivateEquitySponsorService.adminBaseUrl}`
    );
    return await Bixby.API.post(route, command);
  }

  public static async deletePrivateEquitySponsors(id: string): Promise<void> {
    const route = Bixby.API.ServerRoute.forAction(
      `${PrivateEquitySponsorService.adminBaseUrl}/${id}`
    );
    return await Bixby.API.delete(route);
  }

  public static async updatePrivateEquitySponsors(command: Bixby.Models.PrivateEquitySponsorUpdateRequest): Promise<Bixby.Models.PrivateEquitySponsor> {
    const route = Bixby.API.ServerRoute.forAction(
      `${PrivateEquitySponsorService.adminBaseUrl}`
    );
    return await Bixby.API.patch(route, command);
  }
}